import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  Stack,
  Divider,
} from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{ bgcolor: "background.default", py: 3, mt: 4, boxShadow: 1 }}
    >
      <Container maxWidth="lg">
        {/* Top Section */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="body2" color="text.secondary">
            &copy; {new Date().getFullYear()} Security System. All rights
            reserved.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Designed with ♥ for Security Systems
          </Typography>
        </Stack>

        {/* Divider */}
        <Divider sx={{ my: 2 }} />

        {/* Links Section */}
        <Stack direction="row" justifyContent="center" spacing={3}>
          <Link href="termsconditions.html" color="primary" underline="hover">
            Terms & Conditions
          </Link>
          <Link href="privacypolicy.html" color="primary" underline="hover">
            Privacy Policy
          </Link>
          <Link href="/contactus" color="primary" underline="hover">
            Contact Us
          </Link>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
